import React from 'react';
import { LogoProps } from 'types/components.types';
import classfiLogo from 'assets/logo/Classfi_logo.png';
import classfiLong from 'assets/logo/classfi_long.png';
import classfiIcon from 'assets/logo/classfi_no_name.png';

const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  size = 'md',
  variant = 'full',
  alt = 'Classifi'
}) => {
  // Logo sources mapping
  const logoSources = {
    full: classfiLogo,      // Full logo with name (Classfi_logo.png)
    long: classfiLong,      // Horizontal long logo
    icon: classfiIcon       // Icon only (no text)
  };

  // Size presets for consistent sizing across app
  const sizeClasses = {
    sm: 'h-6',      // 24px - For compact areas
    md: 'h-8',      // 32px - Default size
    lg: 'h-10',     // 40px - For headers
    xl: 'h-16'      // 64px - For hero sections
  };

  // Get the appropriate logo source
  const logoSrc = logoSources[variant as keyof typeof logoSources] || logoSources.full;
  const sizeClass = sizeClasses[size] || sizeClasses.md;

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={`${sizeClass} w-auto object-contain ${className}`}
      loading="lazy"
    />
  );
};

export default Logo;
